import * as yup from "yup";

yup.addMethod(yup.string, "isValidPhone", function (errorMessage) {
    return this.test("is-valid-phone", errorMessage, function (value) {
        const { path, createError } = this;

        if (!value) return true;

        if (!/^\+?\d*$/.test(value)) return createError({ path, message: "Letters are not allowed" });

        if (value.replace(/\D/g, "").length > 12) {
            return createError({ path, message: "Maximum of 12 characters" });
        }
        if (value.length < 7) {
            return createError({ path, message: "Minimum of 7 characters" });
        }

        return true;
    });
});
yup.addMethod(yup.string, "emailRegex", function (errorMessage) {
    return this.test("email-regex", errorMessage, function (value) {
        const { path, createError } = this;

        if (!value) return true;

        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
            return createError({ path, message: errorMessage });
        }

        return true;
    });
});
